import React, { useState } from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'

import * as styles from './styles.module.scss'
import { animated, useTransition } from 'react-spring'
import InView from 'react-intersection-observer'

interface Item {
	title: string
	logo: string
	url?: string
}

const _items: Item[] = [
	{
		title: 'Vogue',
		logo: '/2021/images/media/vogue.svg',
		url: '/2021/media-pdfs/vogue.pdf'
	},
	{
		title: 'Forbes',
		logo: '/2021/images/media/forbes.svg',
		url: 'https://forbes.cz/rekord-pro-online-kosmetiku-notino-loni-dosahlo-obratu-145-miliard/'
	},
	{
		title: 'Cosmopolitan',
		logo: '/2021/images/media/cosmopolitan.svg',
		url: '/2021/media-pdfs/cosmopolitan.pdf'
	},
	{
		title: "Harper's bazaar",
		logo: '/2021/images/media/bazaar.png',
		url: 'https://www.harpersbazaar.cz/c/notino-otevrelo-svou-nejvetsi-prodejnu-v-ceske-republice/'
	},
	// { title: 'Marianne', logo: '/2021/images/media/marianne.svg' },
	{
		title: 'iDnes',
		logo: '/2021/images/media/idnes.jpg',
		url: 'https://www.idnes.cz/ekonomika/podniky/parfumerie-notino-nova-prodejna-brno.A210728_122443_ekoakcie_rie'
	},
	{
		title: 'Claudia',
		logo: '/2021/images/media/claudia.svg',
		url: 'https://www.claudia.pl/artykul/skora-po-opalaniu-jak-o-nia-zadbac-domowe-spa-z-eko-kolekcja-notino-spa'
	},
	{
		title: 'Glamour',
		logo: '/2021/images/media/glamour.svg',
		url: '/2021/media-pdfs/glamour.pdf'
	},
	{
		title: 'Elle',
		logo: '/2021/images/media/elle.svg',
		url: '/2021/media-pdfs/elle_pl.pdf'
	},
	{
		title: 'La Repubblica',
		logo: '/2021/images/media/la-repubblica.svg',
		url: 'https://www.repubblica.it/economia/rapporti/osserva-italia/le-storie/2021/12/01/news/notino_da_record_cresce_del_100_il_fatturato_italiano-328486413/'
	},
	{
		title: 'TV Nova',
		logo: '/2021/images/media/nova.png',
		url: '/2021/videos/nova.mp4'
	},
	{
		title: 'Česká televize',
		logo: '/2021/images/media/ct.svg',
		url: '/2021/videos/ct.mp4'
	},
	{ title: 'ČTK', logo: '/2021/images/media/ctk.png' },
	{
		title: 'MF Dnes',
		logo: '/2021/images/media/mfdnes.png',
		url: '/2021/media-pdfs/mfdnes.pdf'
	},
	{
		title: 'Hospodářské noviny',
		logo: '/2021/images/media/hn.svg',
		url: 'https://byznys.hn.cz/c1-66877670-nakupy-drogerie-se-presunuly-na-internet-notino-loni-utrzilo-rekordnich-14-5-miliardy-korun-vzrostl-zajem-o-kosmetiku'
	},
	{
		title: 'Lidovky',
		logo: '/2021/images/media/lidovky.svg',
		url: 'https://www.lidovky.cz/byznys/notino-expanze-evropa.A211104_154621_ln_ekonomika_kov'
	},
	{
		title: 'E15',
		logo: '/2021/images/media/e15.jpg',
		url: 'https://www.e15.cz/rozhovory/pandemie-urychlila-mezirocni-rust-notina-temer-o-polovinu-rika-sef-obchodu-firmy-masika-1382812'
	},
	{
		title: 'Seznam Zprávy',
		logo: '/2021/images/media/seznam-zpravy.png',
		url: 'https://www.seznamzpravy.cz/clanek/ceske-notino-expanduje-do-irska-a-baltskych-zemi-179535'
	},
	{
		title: 'Euro',
		logo: '/2021/images/media/eurocz.png',
		url: 'https://www.euro.cz/byznys/notino-se-opet-vydava-do-sveta-ceska-parfumerie-provonela-v-ramci-dalsi-expanze-pobalti-a-irsko'
	},
	{
		title: 'Marketing & Media',
		logo: '/2021/images/media/mam.png',
		url: '/2021/media-pdfs/mam.png'
	},
	{
		title: 'Eva',
		logo: '/2021/images/media/eva.svg?v=1',
		url: 'https://www.eva.ro/frumusete/stiri/notino-mentine-atmosfera-de-vara-pe-tot-parcursul-anului-cu-pastel-collection-articol-259597.html'
	},
	{
		title: 'Polki',
		logo: '/2021/images/media/polki.svg',
		url: 'https://polki.pl/moda-i-uroda/twarz-i-makijaz,akcesoria-do-makijazu-czy-wystroj-sklepu-z-cukierkami-pedzle-i-gabki-ktore-chcialoby-sie-zjesc,10440461,artykul.html'
	},
	{
		title: 'Marie Claire',
		logo: '/2021/images/media/marieclaire.svg',
		url: 'https://www.marieclaire.it/bellezza/viso-corpo/g38164960/regali-natale-belli-2021/'
	}
]

const Media: React.FC = () => {
	const { t } = useTranslation()

	const [items, setItems] = useState<Item[]>([])

	const transitions = useTransition(items, {
		from: { opacity: 0 },
		enter: { opacity: 1 },
		delay: 1000,
		trail: 200
	})

	return (
		<section className="position-relative">
			<div className="container">
				<h2 className="text-center mt-4 mb-6">{t('media.title')}</h2>
				<InView onChange={(inView) => inView && setItems(_items)}>
					<div className="text-center">
						{transitions((style, item) => (
							<animated.a
								href={item.url}
								title={item.title}
								target="_blank"
								style={style}
							>
								<img src={item.logo} alt={item.title} className={styles.logo} />
							</animated.a>
						))}
					</div>
				</InView>
			</div>
		</section>
	)
}

export default Media
